import { render, staticRenderFns } from "./CardVerVotantesxPersonal.vue?vue&type=template&id=4434e1c0&scoped=true"
import script from "./CardVerVotantesxPersonal.vue?vue&type=script&lang=js"
export * from "./CardVerVotantesxPersonal.vue?vue&type=script&lang=js"
import style0 from "./CardVerVotantesxPersonal.vue?vue&type=style&index=0&id=4434e1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434e1c0",
  null
  
)

export default component.exports